// extracted by mini-css-extract-plugin
export var addToCartButton = "_p8-b";
export var arrowButtonContainer = "_p8-9";
export var arrowButtonIcon = "_p8-a";
export var carouselArrowButton = "_p8-6";
export var carouselElementContainer = "_p8-1";
export var left = "_p8-7";
export var productDisplayCarouselContainer = "_p8-0";
export var productTileContainer = "_p8-2";
export var productTileImage = "_p8-4";
export var productTileImageContainer = "_p8-3";
export var productTileTitle = "_p8-5";
export var right = "_p8-8";
export var sliderOverflow = "_p8-c";